@if (!editing) {
  <div
    (click)="startEditing()"
    [textContent]="name"
    class="group-edit-handler">
  </div>
}
@if (editing) {
  <input
    #nameInput
    class="group-edit-in-place--input"
    type="text"
    opAutofocus
    [(ngModel)]="editedName"
    [attr.placeholder]="placeholder"
    (blur)="saveEdition($event)"
    (keydown.escape)="reset()"
    (keydown.enter)="saveEdition($event)">
}
